// extracted by mini-css-extract-plugin
export var layoutContainer = "_4b-0";
export var layoutContainerNoRounding = "_4b-6";
export var layoutContainerOpen = "_4b-5";
export var layoutContainerResizing = "_4b-1";
export var mainContent = "_4b-2";
export var resizeDivider = "_4b-3";
export var slidePanel = "_4b-4";